import { format, parseISO } from 'date-fns';
import { DatePreference, useWeddingDatePreferencesQuery, WeddingDatePreferences } from '../generated/graphql';
import { getCountDown } from './getCountDown';
import { utcDateToString } from '../components/BasicInfoRail/helpers';

interface UseDatePrefProps {
  isLiteSite: boolean;
}

export const formatDate = (date: string) => (date ? format(parseISO(date), 'MMMM d, yyyy') : '');
export const formatDateRange = (start: string, end: string) =>
  `${formatDate(utcDateToString(start))} - ${formatDate(utcDateToString(end))}`;
export const TO_BE_ANNOUNCED_COPY = 'Date To Be Announced';
export const ADD_WEDDING_DATE_COPY = 'Add your Wedding Date';

const getWeddingDateText = (data: WeddingDatePreferences | null, isLiteSite: boolean): string => {
  const preference = data?.datePreference;
  const weddingDate = data?.weddingDate;
  const hideCountdown = data?.hideCountdown;
  const season = data?.season;
  const rangeStart = data?.weddingDateRangeStart;
  const rangeEnd = data?.weddingDateRangeEnd;
  const year = data?.year;

  if (data === null) return ADD_WEDDING_DATE_COPY;

  if (isLiteSite && preference === DatePreference.Exact && weddingDate) {
    return formatDate(weddingDate);
  } else if (preference === DatePreference.Exact && weddingDate) {
    return `${formatDate(weddingDate)}${getCountDown(weddingDate, hideCountdown)}`;
  } else if (preference === DatePreference.Season && season) {
    return `${season}, ${year}`;
  } else if (preference === DatePreference.Range && rangeStart && rangeEnd) {
    return formatDateRange(rangeStart, rangeEnd);
  } else if (preference === DatePreference.Tba) {
    return TO_BE_ANNOUNCED_COPY;
  } else {
    return ADD_WEDDING_DATE_COPY;
  }
};

const useDatePref = ({ isLiteSite }: UseDatePrefProps): [string] => {
  const { data } = useWeddingDatePreferencesQuery();
  const text = getWeddingDateText(data?.weddingDatePreferences || null, isLiteSite);

  return [text];
};

export default useDatePref;
